export default __webpack_public_path__ + "static/menu-tachibanaudon-min3-999a32c1dc4ee8a47a4d5f377776e473.jpg";